import { httpClient } from "../http-client";
import { NEW_API_ENDPOINTS } from "../../../shared/constants/api";
import type {
  ApiResponseBoolean,
  ApiResponseCompanyDetailResponse,
  ApiResponseGetRequestedCompanyResponse,
  Pageable,
} from "../../../shared/types/api";

export class CompanyApiService {
  async cancelRequestedCompany(
    companyAdminId: number,
  ): Promise<ApiResponseBoolean> {
    const response = await httpClient.put<ApiResponseBoolean>(
      NEW_API_ENDPOINTS.adminController.PUT.cancelRequest,
      { companyAdminId },
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "업체 요청을 거절하지 못했습니다.",
      );
    }

    return response.data;
  }

  async approveCompany(companyAdminId: number): Promise<ApiResponseBoolean> {
    const response = await httpClient.post<ApiResponseBoolean>(
      NEW_API_ENDPOINTS.adminController.POST.approveRequest,
      { companyAdminId },
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "업체 요청을 수락하지 못했습니다.",
      );
    }

    return response.data;
  }

  async getCompanyInfo(
    companyId: number,
  ): Promise<ApiResponseCompanyDetailResponse> {
    const response = await httpClient.get<ApiResponseCompanyDetailResponse>(
      NEW_API_ENDPOINTS.adminController.GET.byId(companyId),
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "업체 정보를 가져오지 못했습니다.",
      );
    }

    return response.data;
  }

  async getRequestedCompany(
    request: Pageable,
  ): Promise<ApiResponseGetRequestedCompanyResponse> {
    const queryParams = new URLSearchParams();
    queryParams.append("page", String(request.page));
    queryParams.append("size", String(request.size));
    if (request.sort) {
      queryParams.append("sort", request.sort?.join(","));
    }

    const response =
      await httpClient.get<ApiResponseGetRequestedCompanyResponse>(
        `${NEW_API_ENDPOINTS.adminController.GET.requests}?${queryParams.toString()}`,
      );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "요청을 보낸 업체들을 불러오지 못했습니다.",
      );
    }

    return response.data;
  }
}

export const adminApiService = new CompanyApiService();
